
import { MOCK_DATES, MOCK_LOANS } from './shared.mock';

export type DocumentType =
  | 'Monthly Billing Statement'
  | 'IRS 1098'
  | '1099 INT'
  | 'Escrow Analysis'
  | 'Annual Statement'
  | 'Payment Confirmation'
  | 'Payoff Statement'
  | 'Letter';

function buildDocument(id: string, loanNumber: string, documentType: DocumentType, daysAgo: number, path: string) {
  return {
    documentId: id,
    loanNumber,
    documentType,
    documentDate: MOCK_DATES.documentDate(daysAgo),
    documentPath: path,
  };
}

export const documentsMock = {
  'with-documents': [
    buildDocument(
      'doc-1',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/statement-dec-2024.pdf'
    ),
    buildDocument(
      'doc-2',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      35,
      '/documents/statement-nov-2024.pdf'
    ),
    buildDocument(
      'doc-3',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      65,
      '/documents/statement-oct-2024.pdf'
    ),
    buildDocument('doc-4', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 350, '/documents/1098-2023.pdf'),
    buildDocument('doc-5', MOCK_LOANS.mortgage.loanNumber, '1099 INT', 350, '/documents/1099-int-2023.pdf'),
  ],

  'no-documents': [],

  'tax-forms-only': [
    buildDocument('doc-1', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 350, '/documents/1098-2023.pdf'),
    buildDocument('doc-2', MOCK_LOANS.mortgage.loanNumber, '1099 INT', 350, '/documents/1099-int-2023.pdf'),
    buildDocument('doc-3', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 715, '/documents/1098-2022.pdf'),
    buildDocument('doc-4', MOCK_LOANS.mortgage.loanNumber, '1099 INT', 715, '/documents/1099-int-2022.pdf'),
  ],

  'multiple-loans': [
    buildDocument(
      'doc-1',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/mortgage-statement-dec-2024.pdf'
    ),
    buildDocument(
      'doc-2',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      35,
      '/documents/mortgage-statement-nov-2024.pdf'
    ),
    buildDocument(
      'doc-3',
      MOCK_LOANS.heloc.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/heloc-statement-dec-2024.pdf'
    ),
    buildDocument(
      'doc-4',
      MOCK_LOANS.heloc.loanNumber,
      'Monthly Billing Statement',
      35,
      '/documents/heloc-statement-nov-2024.pdf'
    ),
    buildDocument(
      'doc-5',
      MOCK_LOANS.homeEquity.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/homeequity-statement-dec-2024.pdf'
    ),
    buildDocument('doc-6', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 350, '/documents/mortgage-1098-2023.pdf'),
    buildDocument('doc-7', MOCK_LOANS.heloc.loanNumber, 'IRS 1098', 350, '/documents/heloc-1098-2023.pdf'),
  ],

  'with-escrow': [
    buildDocument(
      'doc-1',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/statement-dec-2024.pdf'
    ),
    buildDocument(
      'doc-2',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      35,
      '/documents/statement-nov-2024.pdf'
    ),
    buildDocument(
      'doc-3',
      MOCK_LOANS.mortgage.loanNumber,
      'Escrow Analysis',
      30,
      '/documents/escrow-analysis-2024.pdf'
    ),
    buildDocument(
      'doc-4',
      MOCK_LOANS.mortgage.loanNumber,
      'Annual Statement',
      60,
      '/documents/annual-statement-2024.pdf'
    ),
    buildDocument('doc-5', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 350, '/documents/1098-2023.pdf'),
  ],

  'full-set': [
    buildDocument(
      'doc-1',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      5,
      '/documents/statement-jan-2025.pdf'
    ),
    buildDocument(
      'doc-2',
      MOCK_LOANS.mortgage.loanNumber,
      'Monthly Billing Statement',
      35,
      '/documents/statement-dec-2024.pdf'
    ),
    buildDocument(
      'doc-3',
      MOCK_LOANS.mortgage.loanNumber,
      'Escrow Analysis',
      30,
      '/documents/escrow-analysis-2024.pdf'
    ),
    buildDocument('doc-4', MOCK_LOANS.mortgage.loanNumber, 'Letter', 45, '/documents/payment-reminder-letter.pdf'),
    buildDocument('doc-5', MOCK_LOANS.mortgage.loanNumber, 'Letter', 90, '/documents/annual-notice-letter.pdf'),
    buildDocument('doc-6', MOCK_LOANS.mortgage.loanNumber, 'IRS 1098', 350, '/documents/1098-2023.pdf'),
    buildDocument('doc-7', MOCK_LOANS.mortgage.loanNumber, '1099 INT', 350, '/documents/1099-int-2023.pdf'),
  ],
};

export const downloadDocumentMock = {
  success: {
    isSuccess: true,
    documentUrl: 'https://storage.example.com/documents/temp-download-link.pdf',
    expiresAt: MOCK_DATES.futureDate(1),
  },
  'not-found': {
    isSuccess: false,
    message: 'Document not found or no longer available.',
  },
  error: {
    isSuccess: false,
    message: 'Unable to retrieve document. Please try again.',
  },
};
